import { useState, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { ModalContext } from '../ModalContext'
import { EnvelopeIcon } from '@heroicons/react/20/solid'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import { setCoachInviteEmail, setLatestCoachInviteTimestamp } from 'redux/slices/athleteProfile'
import moment from 'moment'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function PlainTextEmailPreviewModal() {

    const dispatch = useDispatch()

    const { modalData, HideModal } = useContext(ModalContext)

    const coachId = useSelector(state => state.user.id)
    const coachFirstName = useSelector(state => state.user.firstName)
    const coachLastName = useSelector(state => state.user.lastName)
    const organizationId = useSelector(state => state.user.organizationId)
    const organizationName = useSelector(state => state.user.organizationName)
    const coachInviteEmail = useSelector(state => state.athleteProfile.coachInviteEmail)
    const coachInviteSignUpCode = useSelector(state => state.athleteProfile.coachInviteSignUpCode)
    const athleteId = useSelector(state => state.athleteProfile.userId)
    const latestCoachInviteTimestamp = useSelector(state => state.athleteProfile.latestCoachInviteTimestamp)

    const [showCopiedTextConfirmation, setShowCopiedTextConfirmation] = useState(false)
    const [athleteEmail, setAthleteEmail] = useState(coachInviteEmail)
    const [inviteLoading, setInviteLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const HandleCopyLink = async () => {
        navigator.clipboard.writeText(modalData.plainText)
        setShowCopiedTextConfirmation(true)
        await new Promise(resolve => setTimeout(resolve, 1000))
        setShowCopiedTextConfirmation(false)
    }

    const SendInvite = async () => {

        setInviteLoading(true)

        const jsonBody = {
            coachId: coachId, 
            coachFirstName: coachFirstName,
            coachLastName: coachLastName,
            organizationId: organizationId,
            organizationName: organizationName,
            coachInviteSignUpCode: coachInviteSignUpCode,
            athleteId: athleteId,
            recipientEmail: athleteEmail
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI("EMAIL", "POST", "/invite_athlete_to_sign_up_with_coach", jsonBody);

        // console.log(result)

        if (result.data.status === "failure") {
            setErrorMessage(result.data.message)
            setInviteLoading(false)
            return
        }

        dispatch(setCoachInviteEmail(athleteEmail))
        dispatch(setLatestCoachInviteTimestamp(moment.utc().format('YYYY-MM-DD HH:mm:ss')))

        setInviteLoading(false)

        HideModal()
    }

    return (
        <>
            <div className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-orange-400">
                <EnvelopeIcon className="h-8 w-8 text-white" aria-hidden="true" />
            </div>

            <div className="text-center text-lg font-semibold leading-6 text-gray-900">{modalData.titleText}</div>

            <div className="space-y-2">
                {modalData.bodyText.map((text, index) => (
                    <p key={index} className="text-sm text-gray-600">
                        {text}
                    </p>
                ))}
            </div>

            <div 
                className="max-h-[50vh] overflow-y-auto relative p-4 bg-gray-100 border rounded-lg text-left cursor-pointer"
                onClick={HandleCopyLink}
            >
                {modalData.plainText.split('\n').map((line, index) => (
                    <span 
                        key={index} 
                        className='text-sm text-gray-800'
                    >
                        {line}
                        <br />
                    </span>
                ))}

                {!showCopiedTextConfirmation && 
                    <DocumentDuplicateIcon className="absolute right-2 top-2 h-5 w-5 text-gray-400 hover:text-gray-600 cursor-pointer" />
                }

                {showCopiedTextConfirmation && 
                    <div className="absolute right-2 top-1.5 h-5 text-sm text-gray-400 font-bold">Text copied!</div>
                }
            </div>

            {modalData.includeSendFunctionality && (
                <>
                    <input
                        type="text"
                        className="w-full py-2 px-4 rounded-md border border-gray-300 bg-white text-center placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                        placeholder='Enter Athlete Email Here'
                        value={athleteEmail}
                        onChange={(event) => setAthleteEmail(event.target.value)}
                    />

                    {errorMessage !== '' && (
                        <p className="text-sm text-red-500 font-bold">{errorMessage}</p>
                    )}

                    <BrandColorButton
                        text="Invite Athlete"
                        action={SendInvite}
                        isLoading={inviteLoading}
                    />

                    {latestCoachInviteTimestamp && (
                        <p className="text-xs text-gray-500">
                            Last invite sent on {moment.utc(latestCoachInviteTimestamp).local().format('MMMM Do, YYYY hh:mm A')}
                        </p>
                    )}
                </>
            )}
        </>
    )
}
